import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { Components_Chip_51BC9844 } from "../Components/Chip.js";
import { Tickets_Severity__get_BackgroundColor, Tickets_Severity__get_ColorCode, Tickets_Severity__ToString_12C6553D } from "../Shared/Shared.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import Warning from "@mui/icons-material/Warning";

export function Activities_SeverityChip_2E7B7895(activity) {
    const ctx = reactApi.useContext(ctx_1);
    const $key6362B0CA = `activity-${activity.Id}-severity`;
    return createElement(Components_Chip_51BC9844, {
        key: $key6362B0CA,
        $key: $key6362B0CA,
        primary: Tickets_Severity__ToString_12C6553D(activity.Severity, ctx.Language),
        enabled: true,
        color: Tickets_Severity__get_ColorCode(activity.Severity),
        backgroundColor: Tickets_Severity__get_BackgroundColor(activity.Severity),
        startIcon: (props) => {
            const props_2 = createObj(props);
            return react.createElement(Warning, props_2);
        },
    });
}

